module.exports = __webpack_public_path__ + "static/media/ghost-tile.ea24e82f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ghost-tile.jpg
// module id = 166
// module chunks = 0